import React, { createContext, useContext, useMemo, useState } from 'react';
import { decodeToken, getAccessToken, removeTokens, setTokens } from '../auth';

const AuthContext = createContext(null);

const buildUserFromToken = (token) => {
  if (!token) {
    return null;
  }
  const decoded = decodeToken(token);
  if (!decoded) {
    return null;
  }
  const userId = decoded?.user_id || null;
  if (!userId) {
    console.error('❌ Token invalide: user_id manquant');
    removeTokens();
    throw new Error('Token invalide');
  }
  return {
    token,
    role: decoded?.role || 'employee',
    team: decoded?.team || null,
    userId,
    email: decoded?.sub || decoded?.email,
  };
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => buildUserFromToken(getAccessToken()));

  const login = ({ accessToken, refreshToken, role, team }) => {
    setTokens(accessToken, refreshToken);
    const nextUser = buildUserFromToken(accessToken) || {
      token: accessToken,
      role: role || 'employee',
      team: team || null,
    };
    setUser(nextUser);
  };

  const logout = () => {
    removeTokens();
    setUser(null);
  };

  const value = useMemo(() => ({ user, login, logout }), [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};

